import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import SelectEvent from '../controls/SelectEvent.jsx';
import {Bar} from 'react-chartjs-2';
import Format from '../../utils/Formatter';
import {setDatetimePicker} from "../controls/DatetimePicker";

class DistribuicaoVendas extends React.Component {
    constructor(props) {
        super(props);
        this.domClassName = 'report-distribuicao-vendas';
        this.inicioDate = '';
        this.fimDate = '';
    }

    componentDidUpdate() {
        let from = "." + this.domClassName + " .inicio-datetime-picker";
        let to = "." + this.domClassName + " .fim-datetime-picker";
        const eventId = this.props.participants.selectedEvent ? this.props.participants.selectedEvent.id : null;

        setDatetimePicker(from, (ev) => {
            $(from).text('Início: ' + ev.text);
            if (this.inicioDate !== ev.query) {
                this.inicioDate = ev.query;
                this.props.events.onListAmountBySlot(eventId, this.inicioDate, this.fimDate, this.props.token);
            }
        });

        setDatetimePicker(to, (ev) => {
            $(to).text('Fim: ' + ev.text);
            if (this.fimDate !== ev.query) {
                this.fimDate = ev.query;
                this.props.events.onListAmountBySlot(eventId, this.inicioDate, this.fimDate, this.props.token);
            }
        });
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.DISTRIBUICAO_VENDAS)
            return null;

        const data = this.props.distribuicaoVendas.results.map(r => r.value);
        const labels = this.props.distribuicaoVendas.results.map(r => moment(r.date).format('HH:mm'));

        const barChartData = {
            labels,
            datasets: [{
                data,
            }],
        };
        const chartOptions = {
            responsive: true,
            legend: {
                display: false,
            },
            scales: {
                yAxes: [{
                    ticks: {
                        callback: (value, index, values) => Format.money(value),
                    }
                }],
            },
            tooltips: {
                mode: 'label',
                callbacks: {
                    label: (tooltipItem, data) => Format.money(tooltipItem.yLabel),
                }
            },
        };

        return (
            <div className={this.domClassName}>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Distribuição temporal de vendas (valor)</h2>
                    </div>
                </div>

                <SelectEvent {...this.props} handleChange={selectedValue => this.props.events.onListAmountBySlot(selectedValue, this.inicioDate, this.fimDate, this.props.token)}/>

                <div className="row">
                    <div className="col-sm-12">
                        <div className="btn-group">
                            <a className="btn btn-default inicio-datetime-picker">
                                <span>Início: não especificado</span>
                            </a>
                            <a className="btn btn-default fim-datetime-picker">
                                <span>Fim: não especificado</span>
                            </a>
                        </div>
                    </div>
                </div>

                <br/>

                <div className="row">
                    <div className="col-sm-12">
                        {data.length > 0 &&
                            <Bar data={barChartData} options={chartOptions}/>
                        }
                        {data.length === 0 &&
                            <h4>Nenhuma venda concluída</h4>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default DistribuicaoVendas;



// WEBPACK FOOTER //
// src/views/pages/DistribuicaoVendas.jsx